import React from "react";
import { Link } from "react-router-dom";

const Sidebar = ({ sidebarOpen, toggleSidebar }) => {
  const logout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  return (
    <div
      className="bg-dark text-white d-flex flex-column col-auto p-0"
      style={{
        width: sidebarOpen ? "220px" : "60px",
        transition: "width 0.3s",
      }}
    >
      <div className="d-flex align-items-center justify-content-between p-3 border-bottom">
        <h3
          className="mb-0"
          style={{
            fontSize: sidebarOpen ? "1.2rem" : "0",
            transition: "font-size 0.3s",
          }}
        >
          {sidebarOpen && "Admin Menu"}
        </h3>
        <button
          className="btn btn-sm btn-outline-light"
          onClick={toggleSidebar}
        >
          <i className="bi bi-list"></i>
        </button>
      </div>

      <div className="flex-grow-1 px-2 mt-3">
        <ul className="nav flex-column">
          <li className="nav-item mb-3">
            <Link className="nav-link text-white" to="/admin">
              <i className="bi bi-speedometer2 me-2"></i>
              {sidebarOpen && "Tableau de bord"}
            </Link>
          </li>
          <li className="nav-item mb-3">
            <Link className="nav-link text-white" to="/admin/users">
              <i className="bi bi-people me-2"></i>
              {sidebarOpen && "Liste utilisateurs"}
            </Link>
          </li>
          <li className="nav-item mb-3">
            <Link className="nav-link text-white" to="/admin/create">
              <i className="bi bi-person-plus me-2"></i>
              {sidebarOpen && "Créer utilisateur"}
            </Link>
          </li>
          <li className="nav-item mb-3">
            <Link className="nav-link text-white" to="/admin/orders">
              <i className="bi bi-box-seam me-2"></i>
              {sidebarOpen && "Gestion commandes"}
            </Link>
          </li>
          {/* Mise à jour: Lien pour l'éditeur d'image */}
          <li className="nav-item mb-3">
            <Link className="nav-link text-white" to="/admin/image-editor">
              <i className="bi bi-image me-2"></i>
              {sidebarOpen && "Éditeur d'image"}
            </Link>
          </li>
          {/* NOUVEAU: Lien pour la galerie d'images */}
          <li className="nav-item mb-3">
            <Link className="nav-link text-white" to="/admin/gallery">
              <i className="bi bi-images me-2"></i>
              {sidebarOpen && "Galerie d'images"}
            </Link>
          </li>
          <li className="nav-item mb-3">
            <Link className="nav-link text-white" to="/">
              <i className="bi bi-house-door me-2"></i>
              {sidebarOpen && "Boutique"}
            </Link>
          </li>
        </ul>
      </div>

      <div className="border-top p-3">
        <button className="btn btn-transparent text-light" onClick={logout}>
          <i className="bi bi-box-arrow-right me-2"></i>
          {sidebarOpen && "Déconnexion"}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;